module.exports = __webpack_public_path__ + "static/media/Nora.06966ef2.jpg";